import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import type { ReactNode } from 'react';

/// Gaveta lateral: a navegação do celular.
///
/// A alternativa era a fileira de abas rolando na horizontal no topo, e ela esconde: o que não
/// coube fica fora da tela sem nada indicar que existe, e achar a última seção exige arrastar às
/// cegas. Aqui a lista aparece inteira, de uma vez, com o polegar alcançando tudo.
///
/// É diálogo de verdade (Radix): prende o foco, fecha no Esc e devolve o foco ao botão que a
/// abriu. Uma `<div>` com `translate-x` não faria nada disso.
export function Drawer({
  open,
  onOpenChange,
  title,
  children,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /// Nome da gaveta para quem não a enxerga. Fica visualmente oculto: na tela, quem diz o que ela
  /// é são o logotipo e os próprios itens.
  title: string;
  children: ReactNode;
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm data-[state=open]:animate-[fade-in_.14s_ease-out]" />
        <Dialog.Content className="fixed inset-y-0 left-0 z-50 flex w-[min(19rem,85vw)] flex-col border-r border-surface-border bg-surface-card outline-none data-[state=open]:animate-[drawer-in_.18s_ease-out]">
          <Dialog.Title className="sr-only">{title}</Dialog.Title>
          <Dialog.Close asChild>
            <button
              type="button"
              aria-label="Fechar menu"
              className="absolute right-3 top-3 z-10 grid size-10 place-items-center rounded-xl border border-surface-border text-content-muted transition hover:border-brand-500/60 hover:text-content focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/50"
            >
              <X className="size-5" aria-hidden="true" />
            </button>
          </Dialog.Close>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
